(
    function (skyward, $, undefined)
    {
        var init = function (selector)
        {
            var GPABucketGroupSummaryPercent = function ()
            {
                var callingElement = event.target.id;
                var groupToTotal = $(selector + " #" + callingElement).data("typegroup");
                var description = $(selector + " #gPABucketTypeDescription-" + groupToTotal).val();
                var total = 0;
                var output;
                var gpa = "";

                $(selector + " input[id^=summaryPercent]").each(function ()
                {
                    if ($(this).data("typegroup") == groupToTotal)
                    {
                        total += parseFloat($(this).val());
                    }
                });

                if (description.toLowerCase().indexOf("GPA") < 0)
                {
                    gpa = " GPA ";
                }

                total = new Number(total).toFixed(2);

                output = description + gpa + "Type - " + total.toString() + "%";


                $(selector + " #typeLabel-" + groupToTotal + "_label").html(output);
            };

            var CumulativeAssignmentScore = function ()
            {
                var total = 0;

                $(selector + " input[id^=Percent]").each(function ()
                {
                    if (parseFloat($(this).val()) > 0)
                    {
                        total += parseFloat($(this).val());
                    }
                });

                total = new Number(100 - total).toFixed(2);

                var output = total.toString();

                $(selector + " #editCalculationGroupGradeBucket_totalPointsPercent").html(output);
            };

            $(selector + " .gradingtotalpercent").on("blur", GPABucketGroupSummaryPercent);
            $(selector + " .selectPercentForCumulativeScore").on("change", CumulativeAssignmentScore);
            $(selector + " .percentForCumulativeScore").on("blur", CumulativeAssignmentScore);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);